// import { get } from "lodash";

export default {
  selectComplianceIncidents: (state) => state.complianceIssues.incidents,
  selectComplianceIssues: (state) => state.complianceIssues.issues,
  selectCompliancePaging: (state) => state.complianceIssues.paging,
  selectComplianceIncidentCount: (state) => state.complianceIssues.incidentCount,
};
